/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_410Inputs */

const en_api_error_410 = /** @type {(inputs: Api_Error_410Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The requested resource is no longer available.`)
};

const pt_br2_api_error_410 = /** @type {(inputs: Api_Error_410Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O recurso solicitado não está mais disponível.`)
};

/**
* | output |
* | --- |
* | "The requested resource is no longer available." |
*
* @param {Api_Error_410Inputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_410 = /** @type {((inputs?: Api_Error_410Inputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_410Inputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_410(inputs)
	return pt_br2_api_error_410(inputs)
});